import DashboardHeader from "../components/DashboardHeader";
import PointsCard from "../components/PointsCard";
import RecentActivity from "../components/RecentActivity";
import "../styles/Dashboard.css";
import { useState, useEffect } from "react";
import { CheckCircle, Calendar, Star } from "lucide-react"; // Am adăugat câteva iconițe pentru un look premium

function Dashboard({ memberData }) {
  const [recentPoints, setRecentPoints] = useState([]);
  const [evenimente, setEvenimente] = useState([]);
  const [evenimenteCount, setEvenimenteCount] = useState(0);
  const [participari, setParticipari] = useState(new Set());
  const [puncteSaptamana, setPuncteSaptamana] = useState(0);
  const [cursuriFinalizateCount, setCursuriFinalizateCount] = useState(0);
  const [activitateRecente, setActivitateRecente] = useState([]);
  const token = "unwantedtok";

  useEffect(() => {
    if (memberData?.id) {
      // Fetch puncte recente
      fetch(`https://prdp-api.suport-949.workers.dev/api/puncte-recent/${memberData.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Nu s-au putut încărca punctele recente.");
          return res.json();
        })
        .then((data) => setRecentPoints(data.length > 0 ? data : []))
        .catch((err) => {
          console.error("Eroare la fetch recentPoints:", err);
          setRecentPoints([]);
        });

      // Fetch progres cursuri membru
      fetch(`https://prdp-api.suport-949.workers.dev/api/progres-membru/${memberData.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Nu s-a putut încărca progresul cursurilor.");
          return res.json();
        })
        .then((progresuri) => {
          const finalizate = progresuri.filter((p) => p.finalizat === true).length;
          setCursuriFinalizateCount(finalizate);
        })
        .catch((err) => {
          console.error("Eroare la fetch progres cursuri:", err);
          setCursuriFinalizateCount(0);
        });

      // Fetch istoricul complet puncte pentru calcul saptamna curenta
      fetch(`https://prdp-api.suport-949.workers.dev/api/puncte-log/${memberData.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Nu s-a putut încărca istoricul punctelor.");
          return res.json();
        })
        .then((data) => {
          const acum = new Date();
          const firstDayOfWeek = new Date(acum);
          firstDayOfWeek.setDate(acum.getDate() - acum.getDay() + 1);
          firstDayOfWeek.setHours(0, 0, 0, 0);

          const puncteSapt = data
            .filter(({ timestamp }) => {
              const dataPunct = new Date(timestamp);
              return dataPunct >= firstDayOfWeek && dataPunct <= acum;
            })
            .reduce((acc, cur) => acc + (cur.puncte || 0), 0);

          setPuncteSaptamana(puncteSapt);
        })
        .catch((err) => {
          console.error("Eroare la fetch istoricul punctelor:", err);
          setPuncteSaptamana(0);
        });

      // Fetch evenimente viitoare
      fetch(`https://prdp-api.suport-949.workers.dev/api/evenimente?future=30`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Nu s-au putut încărca evenimentele.");
          return res.json();
        })
        .then((data) => {
          const acum = new Date();
          const evenimenteValide = data.filter((eveniment) => {
            const dataEveniment = new Date(eveniment.data_ora);
            return dataEveniment >= acum;
          });

          setEvenimente(evenimenteValide);
          setEvenimenteCount(evenimenteValide.length);
        })
        .catch((err) => {
          console.error("Eroare la fetch evenimente:", err);
          setEvenimente([]);
          setEvenimenteCount(0);
        });

      // Fetch inscrieri evenimente membru
      fetch(`https://prdp-api.suport-949.workers.dev/api/membri/${memberData.id}/evenimente`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Nu s-au putut încărca înscrierile.");
          return res.json();
        })
        .then((data) => {
          setParticipari(new Set(data.map((e) => e.id_eveniment)));
        })
        .catch((err) => {
          console.error("Eroare la fetch înscrieri evenimente:", err);
          setParticipari(new Set());
        });

      // Fetch activitate recenta
      fetch(`https://prdp-api.suport-949.workers.dev/api/activitate-recente?id_membru=${memberData.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Nu s-au putut încărca activitatea recentă.");
          return res.json();
        })
        .then((data) => {
          const sorted = data
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .slice(0, 5);
          setActivitateRecente(sorted.length > 0 ? sorted : []);
        })
        .catch((err) => {
          console.error("Eroare la fetch activitateRecente:", err);
          setActivitateRecente([]);
        });
    }
  }, [memberData]);

  const inscrieLaEveniment = async (idEveniment) => {
    try {
      const res = await fetch(
        `https://prdp-api.suport-949.workers.dev/api/evenimente/${idEveniment}/participanti`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id_membru: memberData.id }),
        }
      );
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Eroare la înscriere.");
      }

      const inscrieriRes = await fetch(
        `https://prdp-api.suport-949.workers.dev/api/membri/${memberData.id}/evenimente`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!inscrieriRes.ok) throw new Error("Nu s-au putut actualiza înscrierile...");
      const inscrieriData = await inscrieriRes.json();
      setParticipari(new Set(inscrieriData.map((e) => e.id_eveniment)));
    } catch (err) {
      alert(err.message);
    }
  };

  const dashboardData = {
    stats: [
      { label: "Puncte obținute", sublabel: "(ultima săptămână)", value: puncteSaptamana, icon: Star },
      { label: "Cursuri finalizate", sublabel: "(număr total)", value: cursuriFinalizateCount, icon: CheckCircle },
      { label: "Evenimente", sublabel: "(următoarele 30 zile)", value: evenimenteCount, icon: Calendar },
    ],
  };

  return (
    // Fundal general foarte închis
    <div className="dashboard-wrapper" style={{ overflowX: "hidden", backgroundColor: "#0b1120", minHeight: "100vh", paddingBottom: "40px" }}>
      <DashboardHeader user={memberData} />
      
      <div
        className="container"
        style={{ maxWidth: 1140, margin: "0 auto", padding: "0 16px" }}
      >
        <div className="row g-4 mt-3">
          {/* Cardul de Puncte - Asigură-te că și componenta PointsCard este actualizată la dark mode */}
          <div className="col-12 col-md-4">
            <PointsCard points={memberData.puncte} />
          </div>

          <div className="col-12 col-md-8 d-flex flex-column">
            {/* Rândul cu cele 3 mini-statistici */}
            <div className="row g-3 mb-4">
              {dashboardData.stats.map(({ label, sublabel, value, icon: Icon }, idx) => (
                <div key={idx} className="col-12 col-sm-4">
                  <div
                    className="stats-card h-100"
                    style={{
                      backgroundColor: "#1e293b", // Slate 800
                      border: "1px solid rgba(255, 255, 255, 0.05)",
                      padding: "24px 20px",
                      borderRadius: 20,
                      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-4px)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                  >
                    <div style={{ marginBottom: "12px", background: "rgba(251, 191, 36, 0.1)", padding: "12px", borderRadius: "50%" }}>
                       <Icon size={24} color="#fbbf24" />
                    </div>
                    <div style={{ fontWeight: 600, fontSize: "1rem", color: "#f8fafc", marginBottom: "4px" }}>{label}</div>
                    <div style={{ color: "#94a3b8", fontSize: "0.8rem", marginBottom: "12px" }}>{sublabel}</div>
                    <div style={{ fontSize: "2.25rem", fontWeight: 700, color: "#fbbf24", lineHeight: "1" }}>{value}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Puncte recent atribuite */}
            <div style={{ width: "100%" }}>
              <div
                style={{
                  backgroundColor: "#1e293b",
                  border: "1px solid rgba(255, 255, 255, 0.05)",
                  borderRadius: 20,
                  boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
                  padding: "24px",
                  minHeight: 200,
                }}
              >
                <h4 style={{ color: "#f8fafc", fontWeight: 700, marginBottom: 24, fontSize: "1.25rem" }}>
                  Puncte recent atribuite
                </h4>
                <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                  {recentPoints.length > 0 ? (
                    recentPoints.map((item, idx) => (
                      <li
                        key={idx}
                        style={{
                          backgroundColor: "#0f172a", // Slate 900
                          border: "1px solid rgba(255, 255, 255, 0.05)",
                          borderRadius: 16,
                          padding: "16px 20px",
                          marginBottom: 16,
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 20,
                        }}
                      >
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: 600, color: "#e2e8f0", marginBottom: 4, fontSize: "1rem" }}>{item.action}</div>
                          <div style={{ color: "#94a3b8", marginBottom: 6, fontSize: "0.9rem" }}>{item.desc}</div>
                          <small style={{ color: "#64748b", fontSize: "0.8rem" }}>{item.date}</small>
                        </div>
                        <div
                          style={{
                            color: "#10b981", // Emerald green pentru puncte pozitive
                            fontWeight: 700,
                            fontSize: "1.25rem",
                            minWidth: 40,
                            display: "flex",
                            alignItems: "center"
                          }}
                        >
                          {parseInt(item.points, 10) > 0 ? "+" : ""}
                          {parseInt(item.points, 10)}
                        </div>
                      </li>
                    ))
                  ) : (
                    <li style={{ color: "#64748b", padding: 20, textAlign: "center", fontSize: "0.95rem" }}>
                      Se încarcă punctele recente...
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 mt-2">
          {/* Activitate Recentă */}
          <div className="col-12 col-md-6">
            <RecentActivity
              activities={activitateRecente.map((act) => ({
                type: act.nume_activitate,
                user: `${act.prenume} ${act.nume}`,
                detail: act.detalii,
                time: new Date(act.timestamp).toLocaleString("ro-RO"),
              }))}
            />
          </div>

          {/* Evenimente Viitoare */}
          <div className="col-12 col-md-6">
            <div
              style={{
                backgroundColor: "#1e293b",
                border: "1px solid rgba(255, 255, 255, 0.05)",
                borderRadius: 20,
                boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
                padding: 24,
                maxHeight: 460,
                overflowY: "auto",
              }}
              className="custom-scrollbar"
            >
              <h4 style={{ color: "#f8fafc", fontWeight: 700, marginBottom: 24, fontSize: "1.25rem" }}>
                Evenimente viitoare PRDP
              </h4>
              
              {evenimente.length > 0 ? (
                evenimente.map((eveniment) => {
                  const esteInscris = participari.has(eveniment.id);
                  return (
                    <div
                      key={eveniment.id}
                      style={{
                        backgroundColor: "#0f172a",
                        border: "1px solid rgba(255, 255, 255, 0.05)",
                        borderRadius: 16,
                        padding: 20,
                        marginBottom: 16,
                      }}
                    >
                      <div style={{ fontWeight: 600, fontSize: "1.1rem", color: "#e2e8f0", marginBottom: "8px" }}>
                        {eveniment.titlu}
                      </div>
                      
                      <div style={{ display: "flex", alignItems: "center", marginBottom: 12, color: "#fbbf24", fontSize: "0.85rem", fontWeight: 500 }}>
                        <Calendar size={14} className="me-2" />
                        {new Date(eveniment.data_ora).toLocaleDateString("ro-RO", {
                          day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
                        })}
                        <span className="mx-2">•</span>
                        {eveniment.locatie_tip === "fizic" ? eveniment.locatie_adresa : "Online"}
                      </div>
                      
                      <div style={{ marginBottom: 16, color: "#94a3b8", fontSize: "0.95rem", lineHeight: "1.5" }}>
                        {eveniment.descriere_scurta}
                      </div>

                      <button
                        disabled={esteInscris}
                        onClick={() => inscrieLaEveniment(eveniment.id)}
                        style={{
                          width: "100%",
                          padding: "12px",
                          fontWeight: "600",
                          fontSize: "0.95rem",
                          borderRadius: 12,
                          border: "none",
                          cursor: esteInscris ? "default" : "pointer",
                          backgroundColor: esteInscris ? "rgba(16, 185, 129, 0.1)" : "#fbbf24",
                          color: esteInscris ? "#10b981" : "#0f172a",
                          transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => {
                          if (!esteInscris) e.currentTarget.style.backgroundColor = "#f59e0b";
                        }}
                        onMouseLeave={(e) => {
                          if (!esteInscris) e.currentTarget.style.backgroundColor = "#fbbf24";
                        }}
                      >
                        {esteInscris ? "Ești înscris la acest eveniment" : "Participă la eveniment"}
                      </button>
                    </div>
                  );
                })
              ) : (
                <div style={{ color: "#64748b", fontStyle: "italic", textAlign: "center", padding: "20px 0" }}>
                  Nu există evenimente viitoare în acest moment.
                </div>
              )}
            </div>
          </div>
        </div>

        <footer
          className="dashboard-footer text-center py-4 mt-5"
          style={{ fontSize: "0.85rem", color: "#475569", letterSpacing: "0.5px" }}
        >
          © 2026 PARTIDUL ROMÂNIA DREAPTĂ ȘI PROSPERĂ. TOATE DREPTURILE REZERVATE.
        </footer>
      </div>
      
      {/* Stiluri globale pentru scrollbar custom in dark mode */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #1e293b;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #334155;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #475569;
        }
      `}</style>
    </div>
  );
}

export default Dashboard;
